import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import CategoryIcon from "@mui/icons-material/Category";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import api from "../../api/api";
import AddIcon from "@mui/icons-material/Add";

import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  language_change,
  usertype_change,
  topic_change,
  assessment_change,
} from "./CommonMonthlyQuiz.Slice";
import {
  getCommonQuizTopicThunk,
  getTeacherAssessmentThunk,
  createTeacherAssessmentThunk,
  updateTeacherAssessmentThunk,
  deleteTeacherAssessmentThunk,
} from "./CommonMonthlyQuiz.Thunk";
import Quiz from "../quiz_template/Quiz";

const CommonMonthlyQuiz = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
    { value: "cci", text: "CCI" },
  ];
  // ---------------------------------------------

  // ------------ dropdowns on change ------------
  const language_select_onchange = (event) => {
    dispatch(language_change(event.target.value));
  };
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };
  const topic_select_onchange = (event, value) => {
    dispatch(
      topic_change(
        { topicId: event.target.value, topicName: value.props.children }

        // categoryName: value.props.children,
      )
    );
  };
  // -------------------------------------------------

  // ---------------- navigate to category page -------------
  const navigate_to = () => {
    navigate("/commonquiztopic");
  };
  // ------------------------------------------------------------

  const topicId = useSelector(
    (state) => state.CommonMonthlyQuizSlice.topicId.topicId
  );

  // ------------ Load data & skill ----------------
  const data = useSelector((state) => state.CommonMonthlyQuizSlice.data);
  //console.log("data-->", data);

  // const _id = data.length > 0 ? data[0]["_id"] : "";

  const existing_segments =
    data[0]?.quizData?.length > 0 ? data[0]?.quizData : [];
  //console.log("existing_segments-->", existing_segments);

  const topic_select_option_list = useSelector(
    (state) => state.CommonMonthlyQuizSlice.topic
  );

  const language = useSelector(
    (state) => state.CommonMonthlyQuizSlice.language
  );
  const usertype = useSelector(
    (state) => state.CommonMonthlyQuizSlice.usertype
  );
  //console.log("usertypeset-->", usertype);

  const topicName = useSelector(
    (state) => state.CommonMonthlyQuizSlice.topicName
  );

  //  const questionId = useSelector((state) => state.CommonMonthlyQuizSlice.questionId);

  useEffect(() => {
    const load_category_list = () => {
      const data = {
        usertype: usertype,
        language: "od",
        module: "teacher",
      };
      dispatch(getCommonQuizTopicThunk(data));
    };

    const load_data = () => {
      const prm = { usertype, topicId, language };
      dispatch(getTeacherAssessmentThunk(prm));
    };

    load_category_list();
    load_data();
  }, [dispatch, usertype, language, topicId, topicName]);

  // -----------------------------------------------

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [changeA, setChangeA] = useState("");
  const handleChangeA = (event) => {
    setChangeA(event.target.value);
  };
  const [changeB, setChangeB] = useState("");
  const handleChangeB = (event) => {
    setChangeB(event.target.value);
  };
  const [changeC, setChangeC] = useState("");
  const handleChangeC = (event) => {
    setChangeC(event.target.value);
  };
  const [changeD, setChangeD] = useState("");

  const handleChangeD = (event) => {
    setChangeD(event.target.value);
  };
  const [changeAns, setChangeAns] = useState("");

  const handleChangeAns = (event) => {
    setChangeAns(event.target.value);
  };

  const [changeQuestion, setChangeQuestion] = useState("");
  const handleChangeQuestion = (event) => {
    setChangeQuestion(event.target.value);
  };
  const [questionId, setQuestionId] = useState("");

  // const [changeQuestionOrder, setChangeQuestionOrder] = useState("");
  // const handleChangeQuestion = (event) => {
  //   setChangeQuestion(event.target.value);
  // };
  // const [quizData, setQuizdata] =  useState("");

  const [isLoading, setIsLoading] = useState(false);
  const dataa = {
    topicId: topicId,
    quizData: [
      ...existing_segments,
      {
        optionA: changeA,
        optionB: changeB,
        optionC: changeC,
        optionD: changeD,
        correctOption: changeAns,
        question: changeQuestion,
        questionId: new Date().getTime(),
        questionCategory: "objective",
        questionOrder: "",
        questionType: "text",

        // questionMedia: "",
        // _id: "",
      },
    ],
  };
  //console.log("dataa-->", dataa);

  // const handleSave = () => {
  //   setShow(false);
  //   setIsLoading(true);
  //   toast.success("Changes made successfully");
  //   dispatch(createTeacherAssessmentThunk(dataa)).then((res) => {
  //     const params = { usertype, topicId, language };
  //     dispatch(getTeacherAssessmentThunk(params));
  //   });
  // };

  const handleSave = async () => {
    setShow(false);
    setIsLoading(true);

    try {
      await dispatch(createTeacherAssessmentThunk(dataa));
      toast.success("Changes made successfully", {
        style: {
          backgroundColor: "green",
          color: "white",
          borderRadius: "30px",
        },
      });

      const params = { usertype, topicId, language };
      await dispatch(getTeacherAssessmentThunk(params));
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          toast.error("Internal Server Error. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else if (err.response.status === 504) {
          toast.error("Gateway Timeout. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error(
            `Error: ${err.response.status}. Please try again later.`,
            {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            }
          );
        }
      } else {
        console.error(`The error in getting data: ${err}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const [showUpdate, setShowUpdate] = useState(false);
  const [updateData, setUpdateData] = useState({
    topicId: "",
    quizData: [
      {
        A: "",
        B: "",
        C: "",
        D: "",
        correctOption: "",
        question: "",
      },
    ],
  });
  //console.log("updateData---->", updateData);

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const handleShowUpdate = (eachskill) => {
    setUpdateData({
      A: eachskill.A,
      B: eachskill.B,
      C: eachskill.C,
      D: eachskill.D,
      correctOption: eachskill.correctOption,
      questionId: eachskill.questionId,
      question: eachskill.question,
      questionType: eachskill.questionType,

      // _id: eachskill._id,
    });

    setShowUpdate(true);
  };

  // const handleUpdateChanges = () => {
  //   const updateDataSet = existing_segments.map((item) => {
  //     //console.log("updatecheck---->", item, updateData);

  //     if (item.questionId === updateData.questionId) {
  //       return {
  //         ...item,
  //         A: updateData.A,
  //         B: updateData.B,
  //         C: updateData.C,
  //         D: updateData.D,
  //         correctOption: updateData.correctOption,
  //         question: updateData.question,
  //       };
  //     }
  //     return item;
  //   });

  //   const data = {
  //     topicId: topicId,
  //     quizData: updateDataSet,
  //   };

  //   //console.log("data--", data);
  //   api.put(`updateMasterTtlQuizQuestions`, data).then(
  //     (response) => {
  //       //console.log("response.data---", response.data);
  //       const params = { usertype, topicId, language };
  //       dispatch(getTeacherAssessmentThunk(params));
  //       toast.success("Changes made successfully");
  //     },
  //     (err) => {
  //       //console.log(err);
  //       toast.error("Enter a valid Quiz");
  //     }
  //   );

  //   setShowUpdate(false);
  // };

  const handleUpdateChanges = async () => {
    setShowUpdate(false);
    setIsLoading(true);

    const updateDataSet = existing_segments.map((item) => {
      if (item.questionId === updateData.questionId) {
        return {
          ...item,
          A: updateData.A,
          B: updateData.B,
          C: updateData.C,
          D: updateData.D,
          correctOption: updateData.correctOption,
          question: updateData.question,
        };
      }
      return item;
    });

    const data = {
      topicId: topicId,
      quizData: updateDataSet,
    };

    try {
      const response = await api.put(`updateMasterTtlQuizQuestions`, data);

      if (response.status === 200) {
        const params = { usertype, topicId, language };
        await dispatch(getTeacherAssessmentThunk(params));
        toast.success("Changes made successfully", {
          // style: {
          //   backgroundColor: "green",
          //   color: "white",
          //   borderRadius: "30px",
          // },
        });
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          toast.error("Internal Server Error. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else if (err.response.status === 504) {
          toast.error("Gateway Timeout. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error(
            `Error: ${err.response.status}. Please try again later.`,
            {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            }
          );
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.", {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
        console.error(`The error in updating data: ${err}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // --------------------- nrusingh: save, update, delete quiz --------------------
  const [showQuizDialog, setShowQuizDialog] = useState(false);
  const [action, setAction] = useState("");
  const [params, setParams] = useState(null);

  const quiz_on_close = () => setShowQuizDialog(false);
  const quiz_on_open = (action, quizObject) => {
    const param = { action, quizObject };
    setAction(action);
    setParams(param);
    if (
      language === undefined ||
      language === null ||
      language.trim().length <= 0
    )
      alert("Language is Missing");
    else if (
      usertype === undefined ||
      usertype === null ||
      usertype.trim().length <= 0
    )
      alert("Usertype is Missing");
    else if (
      topicId === undefined ||
      topicId === null ||
      topicId.trim().length <= 0
    )
      alert("Topic is Missing");
    else setShowQuizDialog(true);
  };

  const quiz_on_save = (quizdata) => {
    if (action === "save") save_quiz_data(quizdata);
    else if (action === "update") update_quiz_data(quizdata);
  };

  // const save_quiz_data = (quizdata) => {
  //   setIsLoading(true);
  //   const newdata = {
  //     topicId: topicId,
  //     quizData: [...existing_segments, quizdata],
  //   };

  //   setShowQuizDialog(false);
  //   dispatch(createTeacherAssessmentThunk(newdata)).then((res) => {
  //     const prm = { usertype, topicId, language };
  //     dispatch(getTeacherAssessmentThunk(prm));
  //   });
  // };

  const save_quiz_data = async (quizdata) => {
    setIsLoading(true);
    setShowQuizDialog(false);

    const newdata = {
      topicId: topicId,
      quizData: [...existing_segments, quizdata],
    };

    try {
      const response = await dispatch(createTeacherAssessmentThunk(newdata));

      if (response.error) {
        throw response.error;
      }

      const prm = { usertype, topicId, language };
      await dispatch(getTeacherAssessmentThunk(prm));

      toast.success("Quiz data saved successfully", {
        style: {
          backgroundColor: "green",
          color: "white",
          borderRadius: "30px",
        },
      });
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          toast.error("Internal Server Error. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else if (err.response.status === 504) {
          toast.error("Gateway Timeout. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error(
            `Error: ${err.response.status}. Please try again later.`,
            {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            }
          );
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.", {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
        console.error(`The error in saving data: ${err}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // const update_quiz_data = (quizdata) => {
  //   //console.log("quizdata---->", quizdata);
  //   const updateDataSet = existing_segments.map((item) => {
  //     if (item.questionId === quizdata.questionId) {
  //       //console.log("--> item: ", item);
  //       //console.log("--> quizdata: ", quizdata);
  //       return {
  //         ...item,
  //         ...quizdata,
  //       };
  //     }
  //     return item;
  //   });

  //   const data = {
  //     topicId: topicId,
  //     quizData: updateDataSet,
  //   };

  //   setShowQuizDialog(false);
  //   //console.log("data--", data);
  //   api.put(`updateMasterTtlQuizQuestions`, data).then(
  //     (response) => {
  //       //console.log("response.data---", response.data);
  //       const params = { usertype, topicId, language };
  //       dispatch(getTeacherAssessmentThunk(params));
  //       toast.success("Changes made successfully");
  //     },
  //     (err) => {
  //       //console.log(err);
  //       toast.error("Enter a valid Quiz");
  //     }
  //   );
  // };

  const update_quiz_data = async (quizdata) => {
    setIsLoading(true);
    setShowQuizDialog(false);

    const updateDataSet = existing_segments.map((item) => {
      if (item.questionId === quizdata.questionId) {
        return {
          ...item,
          ...quizdata,
        };
      }
      return item;
    });

    const data = {
      topicId: topicId,
      quizData: updateDataSet,
    };

    try {
      const response = await api.put(`updateMasterTtlQuizQuestions`, data);

      if (response.status === 200) {
        const params = { usertype, topicId, language };
        await dispatch(getTeacherAssessmentThunk(params));
        toast.success("Changes made successfully", {
          style: {
            backgroundColor: "green",
            color: "white",
            borderRadius: "30px",
          },
        });
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          toast.error("Internal Server Error. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else if (err.response.status === 504) {
          toast.error("Gateway Timeout. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error(
            `Error: ${err.response.status}. Please try again later.`,
            {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            }
          );
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.", {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
        console.error(`The error in updating data: ${err}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const quiz_on_update = () => {};

  // ------------------------------------------------------------------------------

  return (
    <>
      <div>
        <MuiHeader header="Common Monthy Quiz" />
        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Usertype"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Topic</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={topicId}
            label="Topic"
            onChange={topic_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {topic_select_option_list.map((option) => (
              <MenuItem key={option.topicId} value={option.topicId}>
                {option.topicName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <FormControl sx={{ m: 1, width: 140, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Assessment</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={type}
            label="Assessment"
            onChange={assessment_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {assessment_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
      </div>
      <div>
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{ m: 1, marginTop: -5, backgroundColor: "blue", height: "38px" }}
          size="small"
        >
          <CategoryIcon
            style={{
              color: "orange",
              marginTop: "-3px",
            }}
          ></CategoryIcon>
          <b style={{ color: "black" }}>Topic</b>
        </Button>
      </div>

      {/* Show List */}
      <div>
        <div>
          {/* {contents.length > 0 ? ( */}
          {/* <Button onClick={handleShow} variant="contained" sx={{ marginTop: 3, float: "left" }}> */}
          <Button
            onClick={() => quiz_on_open("save", null)}
            variant="contained"
            sx={{ marginTop: 3, float: "left" }}
          >
            create
            <AddIcon />
          </Button>
          {/* <QuizTypeMenu selectedMenu={menuItemOnClick}/> */}
          {/* ) : null } */}
          <br />
          <br />
          <br />
          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <br />
              <FormControl sx={{ m: 1 }} size="small">
                <TextField
                  // style={{ width: "300px",wordBreak: "break-all"}}
                  id="filled-basic"
                  label="Question"
                  variant="filled"
                  onChange={handleChangeQuestion}
                />
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2} style={{ marginTop: 12 }}>
                    <Grid item xs={6} md={6}>
                      <TextField
                        //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option A"
                        variant="outlined"
                        onChange={handleChangeA}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                        //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option B"
                        variant="outlined"
                        onChange={handleChangeB}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                        //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option C"
                        variant="outlined"
                        onChange={handleChangeC}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                        //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option D"
                        variant="outlined"
                        onChange={handleChangeD}
                      />
                    </Grid>
                  </Grid>

                  <FormControl sx={{ m: 2, minWidth: 300 }} size="small">
                    <InputLabel id="demo-select-small">Ans:</InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      label="Ans"
                      onChange={handleChangeAns}
                    >
                      <MenuItem value="">
                        <em>Select Answer</em>
                      </MenuItem>
                      <MenuItem value="A">A</MenuItem>
                      <MenuItem value="B">B</MenuItem>
                      <MenuItem value="C">C</MenuItem>
                      <MenuItem value="D">D</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </FormControl>
              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        {topicName ? (
          <table style={{ border: "1px solid blue", marginTop: "0px" }}>
            {existing_segments.map((eachskill, index) => (
              <thead>
                <tr>
                  <th
                    style={{
                      width: "700px",
                      textAlign: "left",
                      wordBreak: "break-all",
                    }}
                  >
                    {" "}
                    {index + 1}.{eachskill?.question}
                  </th>
                </tr>
                <tbody>
                  <tr>
                    <td colSpan="2" style={{ padding: "10px" }}>
                      {eachskill?.instructions && (
                        <div>
                          <b>Instructions-</b> {eachskill?.instructions}
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "350px", wordBreak: "break-all" }}>
                      {eachskill?.optionA && <div>A: {eachskill.optionA}</div>}
                    </td>
                    <td style={{ width: "350px", wordBreak: "break-all" }}>
                      {eachskill?.optionB && <div>B: {eachskill.optionB}</div>}
                    </td>
                    <td>
                      {/* <Button variant="contained" onClick={() => handleShowUpdate(eachskill)}> */}
                      <Button
                        variant="contained"
                        onClick={() => quiz_on_open("update", eachskill)}
                      >
                        Update
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "350px", wordBreak: "break-all" }}>
                      {eachskill?.optionC && <div>C: {eachskill.optionC}</div>}
                    </td>
                    <td style={{ width: "350px", wordBreak: "break-all" }}>
                      {eachskill?.optionD && <div>D: {eachskill.optionD}</div>}
                    </td>
                  </tr>
                  <tr>
                    {eachskill.correctOption &&
                    eachskill.correctOption.length > 0 ? (
                      <td>Answer.{eachskill.correctOption}</td>
                    ) : null}
                  </tr>
                </tbody>
              </thead>
            ))}
          </table>
        ) : null}
        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <TextField
                id="filled-basic"
                label="Objective Question"
                variant="filled"
                value={updateData.question}
                onChange={(e) =>
                  setUpdateData({
                    ...updateData,
                    question: e.target.value,
                  })
                }
              />

              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} style={{ marginTop: 12 }}>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option A"
                      variant="outlined"
                      value={updateData.A}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          A: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option B"
                      variant="outlined"
                      value={updateData.B}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          B: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      // style={{ wordBreak: "break-all"}}
                      id="outlined-basic"
                      label="Option C"
                      variant="outlined"
                      value={updateData.C}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          C: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option D"
                      variant="outlined"
                      value={updateData.D}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          D: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>

                <FormControl sx={{ m: 2, minWidth: 300 }} size="small">
                  <InputLabel id="demo-select-small">Ans:</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    label="Answer"
                    value={updateData.correctOption}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        correctOption: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="">
                      <em>Select Answer</em>
                    </MenuItem>
                    <MenuItem value="A">A</MenuItem>
                    <MenuItem value="B">B</MenuItem>
                    <MenuItem value="C">C</MenuItem>
                    <MenuItem value="D">D</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            <Button variant="contained" onClick={handleUpdateChanges}>
              Update
            </Button>
          </Box>
        </Modal>
      </div>

      {/* Toaster */}
      <ToastContainer />

      {/* nrusing: save modal */}
      <Quiz
        open={showQuizDialog}
        params={params}
        onSubmit={quiz_on_save}
        onClose={quiz_on_close}
      />
    </>
  );
};

export default CommonMonthlyQuiz;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
